































































import { mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import RadioToggle from '@/Shared/RadioToggle.vue';
import { SearchPayload, CustomerPayload, AppellantPayload } from '@/Stores/AppealStore';
import Customer from '@/Customer/Customer';
import { SearchParams } from '../Citation/SearchParams';
import { CheckEmptyOrWhitespace } from '@/Shared/Validator';

const msgBoxOptions = {
    centered: true,
    okVariant: 'danger',
    modalClass: 'deleteRowClass',
    hideBackdrop: true
};
const saveMsgBoxOptions = {
    centered: true,
    okVariant: 'success',
    hideBackdrop: true
};
export default mixins(LocationBasedMixin).extend({
    components: {
        RadioToggle
    },
    props: ['location'],
    computed: {
        ...mapGetters('appealModule', [
            'getCustomer',
            'searchError',
            'getSearchResults',
            'getAppellant',
            'searchInProgress',
            'customerLoaded'
        ]),
        customer(): Customer {
            return this.getCustomer || new Customer();
        }
    },
    mounted() {
        if (!this.getSearchResults.citationNumber) {
            return;
        }

        const searchParams = new SearchParams();
        searchParams.citationNumber = this.getSearchResults.citationNumber;
        searchParams.vehicleState = this.getSearchResults.vehicleState;
        searchParams.vehicleLicense = this.getSearchResults.vehicleLicense;

        if (this.customerLoaded) {
            return;
        }

        const payload: SearchPayload = {
                parameters: searchParams,
                location: this.$typedStore.state.currentLocation
            };

        this.$typedStore.modules.appealModule.actions.searchCustomer(payload);
    },
    data() {
        return {
            customerToAppellant: false,
            i18nPrefix: 'appeals.information'
        };
    },
    methods: {
        async saveCustomer() {
            if (CheckEmptyOrWhitespace(this.getSearchResults.vehicleLicense, 'string')
                || CheckEmptyOrWhitespace(this.getSearchResults.vehicleState, 'string')
                || CheckEmptyOrWhitespace(this.getSearchResults.citationNumber, 'string')) {
                    const message: TranslateResult = this.$t('appeals.information.noCitationMessage');
                    await this.$bvModal.msgBoxConfirm(message.toString(), msgBoxOptions);
                    return;
            }

            const customer = this.getCustomer;
            customer.source = 'Appeals';
            customer.vehicleLicense = this.getSearchResults.vehicleLicense;
            customer.vehicleState = this.getSearchResults.vehicleState;
            customer.citationID = this.getSearchResults.citationNumber;
            customer.userID = this.$typedStore.modules.userModule.getters.userName;

            const payload: CustomerPayload = {
                customer,
                location: this.$typedStore.state.currentLocation
            };

            await this.$typedStore.modules.appealModule.actions.updateCustomer(payload);

            if (this.customerToAppellant) {
                const payloadAppellant: AppellantPayload = {
                    appellant: this.getAppellant,
                    location: this.$typedStore.state.currentLocation
                };

                await this.$typedStore.modules.appealModule.actions.updateAppellant(payloadAppellant);
            }

            const messageSaved: TranslateResult = this.$t('appeals.saveSuccessMessage');
            await this.$bvModal.msgBoxConfirm(messageSaved.toString(), saveMsgBoxOptions);
        },
        async copyCustomerToAppellant() {
            if (!this.customerToAppellant) {
                return;
            }

            const appellant = this.getAppellant;
            appellant.firstName = this.getCustomer.firstName;
            appellant.lastName = this.getCustomer.lastName;
            appellant.address1 = this.getCustomer.address1;
            appellant.address2 = this.getCustomer.address2;
            appellant.city = this.getCustomer.city;
            appellant.state = this.getCustomer.state;
            appellant.zip = this.getCustomer.zip;
            appellant.email = this.getCustomer.emailAddress;
            appellant.phone = this.getCustomer.homePhone;
            appellant.vehicleLicense = this.getSearchResults.vehicleLicense;
            appellant.vehicleState = this.getSearchResults.vehicleState;

            this.$typedStore.modules.appealModule.mutations.setAppellant({
                results: appellant,
                location: this.$typedStore.state.currentLocation
            });
        }
    }
});
